<template>
  <div>
    <h1>Lista firm</h1>

    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search" />
      </v-col>
      <v-spacer />
      <div>
        <v-btn block color="accent">Dodaj nową firmę</v-btn>
      </div>
    </v-row>
    <v-data-table :headers="headers" :items="companies" :search="search" :loading="$store.getters['Ajax/loading'] ? 'accent' : false">
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.name }}</td>
          <td class="text-left">{{ props.item.short_name }}</td>
          <td class="text-left">{{ props.item.alias }}</td>
          <td class="text-left">
            <span />
            <v-chip v-if="props.item.is_enabled" color="success" text-color="white">
              Włączone
              <v-icon right>fa-check-circle</v-icon>
            </v-chip>
            <v-chip v-else color="grey" text-color="white">
              Wyłączone
              <v-icon right>fa-times-circle</v-icon>
            </v-chip>
            <v-chip v-if="props.item.TIN !== null" color="info" text-color="white">
              Xtur
              <v-icon right>fa-check-circle</v-icon>
            </v-chip>
            <v-chip v-else color="grey" text-color="white">
              Xtur
              <v-icon right>fa-times-circle</v-icon>
            </v-chip>
            <v-chip v-if="props.item.is_wnb_enabled" color="primary" text-color="white">
              WNB
              <v-icon right>fa-check-circle</v-icon>
            </v-chip>
            <v-chip v-else color="grey" text-color="white">
              WNB
              <v-icon right>fa-times-circle</v-icon>
            </v-chip>
          </td>

          <td class="text-left">
            <v-btn icon @click="$refs.companyModules.open(props.item.id, props.item.name)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon :disabled="$store.getters['Ajax/loading']" @click="loginInCompanyContext(props.item.id)">
              <v-icon>transfer_within_a_station</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <company-modules ref="companyModules" />
  </div>
</template>

<script>
import CompanyModules from "../../components/CompanyModules";
export default {
  name: "AdminCompaniesView",
  components: { CompanyModules },
  data: () => ({
    companies: [],
    search: null
  }),
  computed: {
    headers() {
      return [
        { text: "Nazwa", value: "name" },
        { text: "Logowanie", value: "short_name" },
        { text: "Alias", value: "alias" },
        { text: "Status", sortable: false },
        { text: this.$t("global.actions"), sortable: false, value: "actions" }
      ];
    }
  },
  created() {
    this.downloadCompanyList();
  },
  methods: {
    loginInCompanyContext(id) {
      this.axios.post("admin/company-admin/log-in-company-context", { id: id }).then(resp => {
        this.$store.commit("TOKEN_CHANGE", resp.data.access_token);
        this.$store.commit("USER_DATA_CHANGE", {
          user_properties: resp.data.user_properties,
          skipSave: false
        });
        this.$store.commit("Shared/allTabsRedirect", "/admin/companies");
      });
    },
    downloadCompanyList() {
      this.axios.get("admin/company-admin/get-list").then(resp => {
        this.companies = resp.data;
      });
    }
  }
};
</script>

<style scoped></style>
